/**
 * @generated SignedSource<<93fbc58d366e8f1f7eb08ed70c033780>>
 * @relayHash 48beb8ab9f8e7637d03cdaf0e1d14b84
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 293b9748216ac77a0d3060cbbe41e1882ff081f088174fe4cb67a5956da44b2f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiAdminPagesFieldsQuery } from './uiAdminPagesFieldsQuery.graphql';

const node: PreloadableConcreteRequest<uiAdminPagesFieldsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "293b9748216ac77a0d3060cbbe41e1882ff081f088174fe4cb67a5956da44b2f",
    "metadata": {},
    "name": "uiAdminPagesFieldsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
